import { UrlMatchResult, UrlSegment } from '@angular/router';

const ITEM_TYPE_SLUGS = new Set(['uslugi', 'datchiki', 'pribor', 'materialy']);

export function canonicalProductCardMatcher(segments: UrlSegment[]): UrlMatchResult | null {
  if (segments[0]?.path === 'komplekty' && segments.length === 4) {
    const [type, serviceSlug, slug, id] = segments;
    return { consumed: segments, posParams: { type, serviceSlug, slug, id } };
  }

  if (ITEM_TYPE_SLUGS.has(segments[0]?.path) && segments.length === 3) {
    const [type, slug, id] = segments;
    return { consumed: segments, posParams: { type, slug, id } };
  }

  return null;
}
